import { supabase } from './supabase'
import { WORKER_URL } from './env'


/**
 * Ask the worker to pull this brand's subscription state straight from the
 * Whop API into brand_configs (POST /api/whop/sync). Closes the
 * checkout-return race: Whop redirects the user back before the
 * membership.activated webhook (the canonical writer) has landed, so the
 * dashboard would otherwise show a free-tier brand until a manual refresh.
 *
 * Returns true when the brand has a live subscription (whether it was just
 * synced or was already in the DB), false when there is none or the call
 * failed — callers treat it as best-effort and keep polling the DB, since
 * the webhook also writes the same row.
 */
export async function syncSubscriptionWithWhop(brandId: string): Promise<boolean> {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    if (!token) return false
    const res = await fetch(`${WORKER_URL}/api/whop/sync`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ brand_id: brandId }),
    })
    if (!res.ok) return false
    const body = await res.json().catch(() => null) as { subscribed?: boolean } | null
    return !!body?.subscribed
  } catch {
    return false
  }
}
